import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PRIVATE_API } from "../../api/apiIndex";

const initialState = {
  data: [],
  error: "",
  status: "idle",
};

export const getContact = createAsyncThunk(
  "contact/getContact",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.get("/contact");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContact.pending, (state, action) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(getContact.fulfilled, (state, action) => {
        state.status = "success";
        state.error = "";
        state.data = action.payload.data;
        // console.log(action);
      })
      .addCase(getContact.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload.message;
      });
  },
});

export const getContactData = (state) => state.contact.data;
export const getContactStatus = (state) => state.contact.status;
export const getContactError = (state) => state.contact.error;

export default contactSlice.reducer;
